import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import AfterLoginNavbar from "components/Navbars/AfterLoginNavbar";
import {
  checkLogin,
  checkUserPermission,
} from "../../../services/CheckUserAccess";

// PatientImport screen
import PatientImport from "./PatientImport";

const Index = (props) => {
  const classes = useStyles();
  const { path } = useRouteMatch();

  const [RedirectLogin, setRedirectLogin] = React.useState(true);

  const [hasUserPermission, setHasUserPermission] = React.useState(false);

  if (RedirectLogin) {
    //here menukey=patients because if allow patient form then patientimport auto allow
    setHasUserPermission(checkUserPermission("patients")); // To check user has permission in this page
    checkLogin();
    setRedirectLogin(false);
  }

  return (
    hasUserPermission && (
      <div>
        <AfterLoginNavbar {...props} />
        <div
          className={`section signup-top-padding ${classes.PatientImportContainer}`}
        >
          <Switch>
            <Route path={`${path}/`} component={PatientImport}></Route>
          </Switch>
        </div>
      </div>
    )
  );
};

export default Index;

const useStyles = makeStyles({
  PatientImportContainer: {
    backgroundImage: "url(" + require("assets/img/bg8.jpg") + ")",
    backgroundSize: "cover",
    backgroundPosition: "top center",
    minHeight: "753px",
  },
});
